import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useLayoutEffect, useState, useRef } from "react";
import RoutingPaths from "helper/routingPath";
import ToastMessages from "helper/toastMessages";
import TableName from "helper/tableName/tableName";
import CommonHeadings from "helper/constant/headings";
import ButtonLabels from "helper/constant/buttonLabels";
import ErrorMessages from "helper/errorMessages";
import { dbFirestore } from "helper/config/firebase";
import HeadingComponent from "components/headingComponent";
import BottomButtons from "components/buttons/bottomButtons";
import { Editor } from 'primereact/editor';
import { addDoc, collection, doc, Timestamp, updateDoc, } from "firebase/firestore";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function AddNotes() {
    const editorRef = useRef(null);
    const [notesHeading, setNotesHeading] = useState(CommonHeadings.notesAddHeading);
    const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [notesID, setNotesID] = useState();
    const navigate = useNavigate();
    const location = useLocation();

    const [notes, setNotes] = useState({
        note_data: "",
    });

    const [errors, setErrors] = useState({
        note_data: "",
    });

    // MARK: Use Effect Method
    useEffect(() => {
        if (location.state) {
            setEditNotesUI();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    //Use Layout Method
    useLayoutEffect(() => {
        document.title = location.state
            ? CommonHeadings.notesEditHeading
            : CommonHeadings.notesAddHeading;
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    //   when we enter any value that's set in the setDemoStudents() and change the input afer submitting like blank all the inputs
    const inputChange = (e) => {
        const html = e.htmlValue;

        setNotes((prev) => ({
            ...prev,
            note_data: html,
        }));
    };


    const validateForm = (data) => {
        const errors = {};
        if (!data.note_data) {
            errors.note_data = ErrorMessages.notesData;
        }

        return errors;
    };

    // MARK: payload function
    function payload() {
        const createdAt = Timestamp.fromDate(new Date()).toMillis();
        const object = {
            ...notes,
            note_data: notes.note_data,
            created_at: createdAt,
            updated_at: null,
        };

        return object;
    }


    // MARK: button

    const tapOnSave = () => {
        const newErrors = validateForm(notes);
        setErrors(newErrors);
        setIsSubmitted(true);
        if (Object.keys(newErrors).length === 0) {
            setLoading1(true);
            if (location.state) {
                updateNotesApi();
            } else {
                writeNotesApi();
            }
        }
    };

    // this function is working when we submit the form by clicking on save andnext button
    const tapOnSaveNext = () => {
        const newErrors = validateForm(notes);
        setErrors(newErrors);
        setIsSubmitted(true);
        if (Object.keys(newErrors).length === 0) {
            setLoading2(true);
            writeNotesApi(true);
        }
    };

    // MARK: reset values function
    function ResetValues() {
        setNotes({
            note_data: "",
        });
    }


    // MARK: edit data function
    async function setEditNotesUI() {

        setNotes({
            note_data: location.state?.note_data,
        });
        setNotesHeading(CommonHeadings.notesEditHeading);
        setButtonLabel(ButtonLabels.updateLabel);
        setNotesID(location.state.id);
    }


    // write API
    async function writeNotesApi(edit) {
        const writePayload = payload();
        try {
            await addDoc(collection(dbFirestore, TableName.notes), writePayload);
            if (edit) {
                toast.success(ToastMessages.noteAdd);
                ResetValues();
                setTimeout(() => {
                    setLoading2(false);
                    // when user press on save + next
                    navigate(RoutingPaths.addNotes);
                    ResetValues();
                }, 600);
            } else {
                toast.success(ToastMessages.noteAdd);
                setTimeout(() => {
                    setLoading1(false);
                    navigate(RoutingPaths.notesList);
                }, 600);
            }
        } catch (error) {
            setLoading1(false); // hide
            setLoading2(false);
            const errorMessage = error.message;
            toast.error(errorMessage);
        }
    }

    // update API
    async function updateNotesApi() {
        const updatedPayload = payload();
        updatedPayload.created_at = location.state.created_at;
        updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();

        try {
            await updateDoc(
                doc(dbFirestore, TableName.notes, notesID),
                {
                    ...updatedPayload,
                }
            );
            toast.success(ToastMessages.noteUpdated);

            setTimeout(() => {
                setLoading1(false); // hide
                setLoading2(false);
                navigate(RoutingPaths.notesList);
            }, 600);
        } catch (error) {
            const errorMessage = error.message;
            toast.error(errorMessage);
        }
    }


    return (
        <div className="modules__main__div">
            <div className="col-12">
                <div className="card modules__card">
                    <HeadingComponent
                        classname="mb-4"
                        headingName={notesHeading}
                    />
                    <div className="p-fluid">
                        <div className="row modules__row">
                            <div className="col-12 col-md-6">
                                <Editor value={notes.note_data} onTextChange={inputChange} style={{ height: '320px' }} />

                                {isSubmitted && (
                                    <small id="note_data" className="p-error">
                                        {errors.note_data}
                                    </small>

                                )}
                            </div>
                        </div>
                    </div>

                    <BottomButtons
                        label={buttonLabel}
                        save={tapOnSave}
                        loading1={loading1}
                        saveNext={tapOnSaveNext}
                        loading2={loading2}
                    />
                    <ToastContainer />

                </div>
            </div>
        </div>
    )
}

export default AddNotes;